/** 
 * @props linkButton: prop for button which is visible as a link.
 * linkButton = {
 *     text: "link button text",
 *     clickCb: () => {}
 * }
 * @props backButton: prop for back button
 * backButton = {
 *     text: "Back",
 *     clickCb: () => {}
 * }
 * @props nextButton: prop for back button
 * nextButton = {
 *     text: "Next",
 *     clickCb: () => {}
 * }
*/

import React from 'react';
import Button from '../button/Button';
import { BUTTON_TYPE } from '../button/constants';
import { VEC_ICON_NAME } from '../icons/constants';
import Icons from '../icons/Icons';
import styles from './FooterWImageAndActionButtons.styles';
import { useEffect } from 'react';
import { useState } from 'react';

export default function FooterWImageAndActionButtons({ children, linkButton, backButton, nextButton = { hideNextButton: false }, showFooterImage = true }) {

    const [selectedIcon, setSeclectedIcon] = useState(0)
    
    const footerIcon = [
        {
            ICON: VEC_ICON_NAME.PRE_LOGIN_FEATURE_ICON1,
            TEXT: "Secured & easy, compliance eFiling software"
        },
        {
            ICON: VEC_ICON_NAME.PRE_LOGIN_FEATURE_ICON2,
            TEXT: "Easy to create, verify, & eFile 1099 forms"
        },
        {
            ICON: VEC_ICON_NAME.PRE_LOGIN_FEATURE_ICON3,
            TEXT: "Get faster eFile acceptance from IRS"
        },
    ]


    useEffect(() => {
        setSeclectedIcon(parseInt(Math.random() * footerIcon.length))
    }, [])


    return <>
        <div style={styles.footerContainer}>
            {showFooterImage && <Icons familyName='vec' iconName={VEC_ICON_NAME.FOOTER_IMAGE} style={styles.footerImage} />}
            <div style={styles.footerContentDiv}>
                {
                    showFooterImage && <div style={styles.footerInfoText}>
                        {
                            (children) ?? <div style={styles.footerIcon}>
                                <Icons familyName={'vec'} iconName={footerIcon[selectedIcon].ICON} />
                                <div>{footerIcon[selectedIcon].TEXT}</div>
                            </div>
                        }
                    </div>
                }
                
                <div style={styles.actionButtonsDiv}>
                    {
                        (linkButton?.clickCb) ? 
                            <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} 
                                onClickCb={linkButton.clickCb} 
                                children={linkButton.text}
                                style={styles.actionButtonStyle}
                            />
                        : ""
                    }
                    {
                        (backButton?.clickCb) ? 
                            <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                                onClickCb={backButton.clickCb} 
                                children={backButton.text}
                                style={styles.actionButtonStyle}
                            />
                            : ""
                    }
                    {
                        (nextButton?.clickCb) ?
                            <Button type={BUTTON_TYPE.PRIMARY}
                                onClickCb={nextButton.disabled ? nextButton?.disabledInfoCb : nextButton.clickCb}
                                children={nextButton.text}
                                style={styles.actionButtonStyle}
                            />
                            : ""
                    }
                </div>
            </div>
        </div>
    </>
}